__webpack_require__.p = "/tools/portfolio-management-game/_next/";